export default "__VITE_ASSET__DhytNZSW__"